/**
 * This is an Auto-generated file, any changes made to this file will not be preserved after build.
 * Please see the README.md file for instructions on how this process works.
 * */
import { createLanguageEnum } from '../typescript/NonReact/Languages/LanguageResourcing'
import { NamedEnumLike } from '../typescript/NonReact/Languages/LanguageTypes'

import ACDCodesLanguageEN_GB from './en_GB/ACDCodesLanguage.json'
import ACDCodesLanguageEN_US from './en_US/ACDCodesLanguage.json'

import ACDDNDActivityEN_GB from './en_GB/ACDDNDActivity.json'
import ACDDNDActivityEN_US from './en_US/ACDDNDActivity.json'

import ACDStateThresholdsEN_GB from './en_GB/ACDStateThresholds.json'
import ACDStateThresholdsEN_US from './en_US/ACDStateThresholds.json'

import ACDStatusHotKeysEN_GB from './en_GB/ACDStatusHotKeys.json'
import ACDStatusHotKeysEN_US from './en_US/ACDStatusHotKeys.json'

import AbandonedCallAlarmEN_GB from './en_GB/AbandonedCallAlarm.json'
import AbandonedCallAlarmEN_US from './en_US/AbandonedCallAlarm.json'

import AbandonedTimeStatisticLanguageEN_GB from './en_GB/AbandonedTimeStatisticLanguage.json'
import AbandonedTimeStatisticLanguageEN_US from './en_US/AbandonedTimeStatisticLanguage.json'

import AddUserLanguageEN_GB from './en_GB/AddUserLanguage.json'
import AddUserLanguageEN_US from './en_US/AddUserLanguage.json'

import AdminActionsLanguageEN_GB from './en_GB/AdminActionsLanguage.json'
import AdminActionsLanguageEN_US from './en_US/AdminActionsLanguage.json'

import AdminOverviewLanguageEN_GB from './en_GB/AdminOverviewLanguage.json'
import AdminOverviewLanguageEN_US from './en_US/AdminOverviewLanguage.json'

import AdministratorLanguageEN_GB from './en_GB/AdministratorLanguage.json'
import AdministratorLanguageEN_US from './en_US/AdministratorLanguage.json'

import AdvancedEN_GB from './en_GB/Advanced.json'
import AdvancedEN_US from './en_US/Advanced.json'

import AgentAdvancedEN_GB from './en_GB/AgentAdvanced.json'
import AgentAdvancedEN_US from './en_US/AgentAdvanced.json'

import AgentDetailsEN_GB from './en_GB/AgentDetails.json'
import AgentDetailsEN_US from './en_US/AgentDetails.json'

import AgentListLanguageEN_GB from './en_GB/AgentListLanguage.json'
import AgentListLanguageEN_US from './en_US/AgentListLanguage.json'

import AgentOmnichannelEN_GB from './en_GB/AgentOmnichannel.json'
import AgentOmnichannelEN_US from './en_US/AgentOmnichannel.json'

import AlarmActionsEN_GB from './en_GB/AlarmActions.json'
import AlarmActionsEN_US from './en_US/AlarmActions.json'

import AnswerPerformanceEN_GB from './en_GB/AnswerPerformance.json'
import AnswerPerformanceEN_US from './en_US/AnswerPerformance.json'

import ApiKeysEN_GB from './en_GB/ApiKeys.json'
import ApiKeysEN_US from './en_US/ApiKeys.json'

import AppMenuEN_GB from './en_GB/AppMenu.json'
import AppMenuEN_US from './en_US/AppMenu.json'

import AuditEN_GB from './en_GB/Audit.json'
import AuditEN_US from './en_US/Audit.json'

import AuthenticationEN_GB from './en_GB/Authentication.json'
import AuthenticationEN_US from './en_US/Authentication.json'

import BrandingLanguageEN_GB from './en_GB/BrandingLanguage.json'
import BrandingLanguageEN_US from './en_US/BrandingLanguage.json'

import BroadworksSSOEN_GB from './en_GB/BroadworksSSO.json'
import BroadworksSSOEN_US from './en_US/BroadworksSSO.json'

import CMECapabilitiesEN_GB from './en_GB/CMECapabilities.json'
import CMECapabilitiesEN_US from './en_US/CMECapabilities.json'

import CMEDetailsEN_GB from './en_GB/CMEDetails.json'
import CMEDetailsEN_US from './en_US/CMEDetails.json'

import CRMConfigurationLanguageEN_GB from './en_GB/CRMConfigurationLanguage.json'
import CRMConfigurationLanguageEN_US from './en_US/CRMConfigurationLanguage.json'

import CRMModalEN_GB from './en_GB/CRMModal.json'
import CRMModalEN_US from './en_US/CRMModal.json'

import CSVExportFormatEN_GB from './en_GB/CSVExportFormat.json'
import CSVExportFormatEN_US from './en_US/CSVExportFormat.json'

import CXRecordLanguageEN_GB from './en_GB/CXRecordLanguage.json'
import CXRecordLanguageEN_US from './en_US/CXRecordLanguage.json'

import CXScoreLanguageEN_GB from './en_GB/CXScoreLanguage.json'
import CXScoreLanguageEN_US from './en_US/CXScoreLanguage.json'

import CallControlErrorsEN_GB from './en_GB/CallControlErrors.json'
import CallControlErrorsEN_US from './en_US/CallControlErrors.json'

import CallDetailsEN_GB from './en_GB/CallDetails.json'
import CallDetailsEN_US from './en_US/CallDetails.json'

import CallMovementFilteringEN_GB from './en_GB/CallMovementFiltering.json'
import CallMovementFilteringEN_US from './en_US/CallMovementFiltering.json'

import CallRecIntegrationEN_GB from './en_GB/CallRecIntegration.json'
import CallRecIntegrationEN_US from './en_US/CallRecIntegration.json'

import CallRecordingEN_GB from './en_GB/CallRecording.json'
import CallRecordingEN_US from './en_US/CallRecording.json'

import CallStateThresholdsEN_GB from './en_GB/CallStateThresholds.json'
import CallStateThresholdsEN_US from './en_US/CallStateThresholds.json'

import CallTargettingEN_GB from './en_GB/CallTargetting.json'
import CallTargettingEN_US from './en_US/CallTargetting.json'

import ChangeLangLanguageEN_GB from './en_GB/ChangeLangLanguage.json'
import ChangeLangLanguageEN_US from './en_US/ChangeLangLanguage.json'

import ChangeLayoutEN_GB from './en_GB/ChangeLayout.json'
import ChangeLayoutEN_US from './en_US/ChangeLayout.json'

import ChangeUserAgentLanguageEN_GB from './en_GB/ChangeUserAgentLanguage.json'
import ChangeUserAgentLanguageEN_US from './en_US/ChangeUserAgentLanguage.json'

import ChartProviderOptionsEN_GB from './en_GB/ChartProviderOptions.json'
import ChartProviderOptionsEN_US from './en_US/ChartProviderOptions.json'

import ChartStyleOptionsEN_GB from './en_GB/ChartStyleOptions.json'
import ChartStyleOptionsEN_US from './en_US/ChartStyleOptions.json'

import ClientConfigurationLanguageEN_GB from './en_GB/ClientConfigurationLanguage.json'
import ClientConfigurationLanguageEN_US from './en_US/ClientConfigurationLanguage.json'

import ClientConfigurationModalLanguageEN_GB from './en_GB/ClientConfigurationModalLanguage.json'
import ClientConfigurationModalLanguageEN_US from './en_US/ClientConfigurationModalLanguage.json'

import CmeListLanguageEN_GB from './en_GB/CmeListLanguage.json'
import CmeListLanguageEN_US from './en_US/CmeListLanguage.json'

import CodeAddModifyEN_GB from './en_GB/CodeAddModify.json'
import CodeAddModifyEN_US from './en_US/CodeAddModify.json'

import CodeListLanguageEN_GB from './en_GB/CodeListLanguage.json'
import CodeListLanguageEN_US from './en_US/CodeListLanguage.json'

import ComboBoxEN_GB from './en_GB/ComboBox.json'
import ComboBoxEN_US from './en_US/ComboBox.json'

import CommonAdminEN_GB from './en_GB/CommonAdmin.json'
import CommonAdminEN_US from './en_US/CommonAdmin.json'

import ConfigChangeLogListLanguageEN_GB from './en_GB/ConfigChangeLogListLanguage.json'
import ConfigChangeLogListLanguageEN_US from './en_US/ConfigChangeLogListLanguage.json'

import ConfigureAgentsEN_GB from './en_GB/ConfigureAgents.json'
import ConfigureAgentsEN_US from './en_US/ConfigureAgents.json'

import ConfigureReportEN_GB from './en_GB/ConfigureReport.json'
import ConfigureReportEN_US from './en_US/ConfigureReport.json'

import ContentRestrictionEN_GB from './en_GB/ContentRestriction.json'
import ContentRestrictionEN_US from './en_US/ContentRestriction.json'

import CookieConsentEN_GB from './en_GB/CookieConsent.json'
import CookieConsentEN_US from './en_US/CookieConsent.json'

import CurrencyEN_GB from './en_GB/Currency.json'
import CurrencyEN_US from './en_US/Currency.json'

import CurrencyDisplayFormatEN_GB from './en_GB/CurrencyDisplayFormat.json'
import CurrencyDisplayFormatEN_US from './en_US/CurrencyDisplayFormat.json'

import CustomSettingsEN_GB from './en_GB/CustomSettings.json'
import CustomSettingsEN_US from './en_US/CustomSettings.json'

import CustomiseRoleEN_GB from './en_GB/CustomiseRole.json'
import CustomiseRoleEN_US from './en_US/CustomiseRole.json'

import CxiLicenceTypesEN_GB from './en_GB/CxiLicenceTypes.json'
import CxiLicenceTypesEN_US from './en_US/CxiLicenceTypes.json'

import DarkModeEN_GB from './en_GB/DarkMode.json'
import DarkModeEN_US from './en_US/DarkMode.json'

import DashboardDisplaySettingsEN_GB from './en_GB/DashboardDisplaySettings.json'
import DashboardDisplaySettingsEN_US from './en_US/DashboardDisplaySettings.json'

import DashboardListEN_GB from './en_GB/DashboardList.json'
import DashboardListEN_US from './en_US/DashboardList.json'

import DashboardOptionsEN_GB from './en_GB/DashboardOptions.json'
import DashboardOptionsEN_US from './en_US/DashboardOptions.json'

import DatabaseLanguageEN_GB from './en_GB/DatabaseLanguage.json'
import DatabaseLanguageEN_US from './en_US/DatabaseLanguage.json'

import DateEN_GB from './en_GB/Date.json'
import DateEN_US from './en_US/Date.json'

import DateTimeEN_GB from './en_GB/DateTime.json'
import DateTimeEN_US from './en_US/DateTime.json'

import DaysOfTheWeekEN_GB from './en_GB/DaysOfTheWeek.json'
import DaysOfTheWeekEN_US from './en_US/DaysOfTheWeek.json'

import DeviceFilteringEN_GB from './en_GB/DeviceFiltering.json'
import DeviceFilteringEN_US from './en_US/DeviceFiltering.json'

import DeviceListLanguageEN_GB from './en_GB/DeviceListLanguage.json'
import DeviceListLanguageEN_US from './en_US/DeviceListLanguage.json'

import DeviceModalEN_GB from './en_GB/DeviceModal.json'
import DeviceModalEN_US from './en_US/DeviceModal.json'

import DeviceTypesLanguageEN_GB from './en_GB/DeviceTypesLanguage.json'
import DeviceTypesLanguageEN_US from './en_US/DeviceTypesLanguage.json'

import DirectoryListLanguageEN_GB from './en_GB/DirectoryListLanguage.json'
import DirectoryListLanguageEN_US from './en_US/DirectoryListLanguage.json'

import DirectoryModalEN_GB from './en_GB/DirectoryModal.json'
import DirectoryModalEN_US from './en_US/DirectoryModal.json'

import DisplayOptionsEN_GB from './en_GB/DisplayOptions.json'
import DisplayOptionsEN_US from './en_US/DisplayOptions.json'

import DisplaySettingsEN_GB from './en_GB/DisplaySettings.json'
import DisplaySettingsEN_US from './en_US/DisplaySettings.json'

import DisplaySwitchingEN_GB from './en_GB/DisplaySwitching.json'
import DisplaySwitchingEN_US from './en_US/DisplaySwitching.json'

import DisplayedAsOptionsEN_GB from './en_GB/DisplayedAsOptions.json'
import DisplayedAsOptionsEN_US from './en_US/DisplayedAsOptions.json'

import DocumentViewerEN_GB from './en_GB/DocumentViewer.json'
import DocumentViewerEN_US from './en_US/DocumentViewer.json'

import DomainProfileEN_GB from './en_GB/DomainProfile.json'
import DomainProfileEN_US from './en_US/DomainProfile.json'

import DurationFilteringEN_GB from './en_GB/DurationFiltering.json'
import DurationFilteringEN_US from './en_US/DurationFiltering.json'

import ErrorLanguageEN_GB from './en_GB/ErrorLanguage.json'
import ErrorLanguageEN_US from './en_US/ErrorLanguage.json'

import EstateEN_GB from './en_GB/Estate.json'
import EstateEN_US from './en_US/Estate.json'

import ExtensionEndpointEN_GB from './en_GB/ExtensionEndpoint.json'
import ExtensionEndpointEN_US from './en_US/ExtensionEndpoint.json'

import FieldsListEN_GB from './en_GB/FieldsList.json'
import FieldsListEN_US from './en_US/FieldsList.json'

import FieldsTabEN_GB from './en_GB/FieldsTab.json'
import FieldsTabEN_US from './en_US/FieldsTab.json'

import FileUploadLanguageEN_GB from './en_GB/FileUploadLanguage.json'
import FileUploadLanguageEN_US from './en_US/FileUploadLanguage.json'

import ForgotPasswordLanguageEN_GB from './en_GB/ForgotPasswordLanguage.json'
import ForgotPasswordLanguageEN_US from './en_US/ForgotPasswordLanguage.json'

import FormatEN_GB from './en_GB/Format.json'
import FormatEN_US from './en_US/Format.json'

import GenericAdminFilterLanguageEN_GB from './en_GB/GenericAdminFilterLanguage.json'
import GenericAdminFilterLanguageEN_US from './en_US/GenericAdminFilterLanguage.json'

import GenericAdminListLanguageEN_GB from './en_GB/GenericAdminListLanguage.json'
import GenericAdminListLanguageEN_US from './en_US/GenericAdminListLanguage.json'

import GenericFooterEN_GB from './en_GB/GenericFooter.json'
import GenericFooterEN_US from './en_US/GenericFooter.json'

import GenericModalEN_GB from './en_GB/GenericModal.json'
import GenericModalEN_US from './en_US/GenericModal.json'

import GenericRuleLanguageEN_GB from './en_GB/GenericRuleLanguage.json'
import GenericRuleLanguageEN_US from './en_US/GenericRuleLanguage.json'

import GenericScopeTabEN_GB from './en_GB/GenericScopeTab.json'
import GenericScopeTabEN_US from './en_US/GenericScopeTab.json'

import HeaderSidebarEN_GB from './en_GB/HeaderSidebar.json'
import HeaderSidebarEN_US from './en_US/HeaderSidebar.json'

import InboundStatSettingsEN_GB from './en_GB/InboundStatSettings.json'
import InboundStatSettingsEN_US from './en_US/InboundStatSettings.json'

import InsightsDashboardLanguageEN_GB from './en_GB/InsightsDashboardLanguage.json'
import InsightsDashboardLanguageEN_US from './en_US/InsightsDashboardLanguage.json'

import InsightsHubEN_GB from './en_GB/InsightsHub.json'
import InsightsHubEN_US from './en_US/InsightsHub.json'

import LanguageBulkInsertUsersEN_GB from './en_GB/LanguageBulkInsertUsers.json'
import LanguageBulkInsertUsersEN_US from './en_US/LanguageBulkInsertUsers.json'

import LanguageBulkUploadDirectoryEntriesEN_GB from './en_GB/LanguageBulkUploadDirectoryEntries.json'
import LanguageBulkUploadDirectoryEntriesEN_US from './en_US/LanguageBulkUploadDirectoryEntries.json'

import LanguageCMEEN_GB from './en_GB/LanguageCME.json'
import LanguageCMEEN_US from './en_US/LanguageCME.json'

import LanguageDataTableEN_GB from './en_GB/LanguageDataTable.json'
import LanguageDataTableEN_US from './en_US/LanguageDataTable.json'

import LanguageErrorCodesEN_GB from './en_GB/LanguageErrorCodes.json'
import LanguageErrorCodesEN_US from './en_US/LanguageErrorCodes.json'

import LanguageErrorsEN_GB from './en_GB/LanguageErrors.json'
import LanguageErrorsEN_US from './en_US/LanguageErrors.json'

import LanguageFallbackNavEN_GB from './en_GB/LanguageFallbackNav.json'
import LanguageFallbackNavEN_US from './en_US/LanguageFallbackNav.json'

import LanguageGeneralEN_GB from './en_GB/LanguageGeneral.json'
import LanguageGeneralEN_US from './en_US/LanguageGeneral.json'

import LanguageLogFileDownloadEN_GB from './en_GB/LanguageLogFileDownload.json'
import LanguageLogFileDownloadEN_US from './en_US/LanguageLogFileDownload.json'

import LanguageMainMenuEN_GB from './en_GB/LanguageMainMenu.json'
import LanguageMainMenuEN_US from './en_US/LanguageMainMenu.json'

import LanguageMainNavigationEN_GB from './en_GB/LanguageMainNavigation.json'
import LanguageMainNavigationEN_US from './en_US/LanguageMainNavigation.json'

import LanguageMyReportListEN_GB from './en_GB/LanguageMyReportList.json'
import LanguageMyReportListEN_US from './en_US/LanguageMyReportList.json'

import LanguageNewUserTutorialEN_GB from './en_GB/LanguageNewUserTutorial.json'
import LanguageNewUserTutorialEN_US from './en_US/LanguageNewUserTutorial.json'

import LanguagePromptEN_GB from './en_GB/LanguagePrompt.json'
import LanguagePromptEN_US from './en_US/LanguagePrompt.json'

import LanguageSnackbarEN_GB from './en_GB/LanguageSnackbar.json'
import LanguageSnackbarEN_US from './en_US/LanguageSnackbar.json'

import LicenceManagementPageLanguageEN_GB from './en_GB/LicenceManagementPageLanguage.json'
import LicenceManagementPageLanguageEN_US from './en_US/LicenceManagementPageLanguage.json'

import LicenseManagementEN_GB from './en_GB/LicenseManagement.json'
import LicenseManagementEN_US from './en_US/LicenseManagement.json'

import LicenseManagementLanguageEN_GB from './en_GB/LicenseManagementLanguage.json'
import LicenseManagementLanguageEN_US from './en_US/LicenseManagementLanguage.json'

import LinkInputLanguageEN_GB from './en_GB/LinkInputLanguage.json'
import LinkInputLanguageEN_US from './en_US/LinkInputLanguage.json'

import LocationalFilteringEN_GB from './en_GB/LocationalFiltering.json'
import LocationalFilteringEN_US from './en_US/LocationalFiltering.json'

import LogManagementListLanguageEN_GB from './en_GB/LogManagementListLanguage.json'
import LogManagementListLanguageEN_US from './en_US/LogManagementListLanguage.json'

import LoggingSettingsLanguageEN_GB from './en_GB/LoggingSettingsLanguage.json'
import LoggingSettingsLanguageEN_US from './en_US/LoggingSettingsLanguage.json'

import MFALanguageEN_GB from './en_GB/MFALanguage.json'
import MFALanguageEN_US from './en_US/MFALanguage.json'

import ManageCustomRolesEN_GB from './en_GB/ManageCustomRoles.json'
import ManageCustomRolesEN_US from './en_US/ManageCustomRoles.json'

import ManageQueuesEN_GB from './en_GB/ManageQueues.json'
import ManageQueuesEN_US from './en_US/ManageQueues.json'

import MediaPlayerEN_GB from './en_GB/MediaPlayer.json'
import MediaPlayerEN_US from './en_US/MediaPlayer.json'

import MessagesLanguageEN_GB from './en_GB/MessagesLanguage.json'
import MessagesLanguageEN_US from './en_US/MessagesLanguage.json'

import MicrosoftSSOEN_GB from './en_GB/MicrosoftSSO.json'
import MicrosoftSSOEN_US from './en_US/MicrosoftSSO.json'

import MiscellaneousFilteringEN_GB from './en_GB/MiscellaneousFiltering.json'
import MiscellaneousFilteringEN_US from './en_US/MiscellaneousFiltering.json'

import MonetaryCallAssignmentsEN_GB from './en_GB/MonetaryCallAssignments.json'
import MonetaryCallAssignmentsEN_US from './en_US/MonetaryCallAssignments.json'

import NotificationsLanguageEN_GB from './en_GB/NotificationsLanguage.json'
import NotificationsLanguageEN_US from './en_US/NotificationsLanguage.json'

import NotificationsLanguageModalEN_GB from './en_GB/NotificationsLanguageModal.json'
import NotificationsLanguageModalEN_US from './en_US/NotificationsLanguageModal.json'

import OAuthButtonEN_GB from './en_GB/OAuthButton.json'
import OAuthButtonEN_US from './en_US/OAuthButton.json'

import PaginatedListEN_GB from './en_GB/PaginatedList.json'
import PaginatedListEN_US from './en_US/PaginatedList.json'

import PartitionListLanguageEN_GB from './en_GB/PartitionListLanguage.json'
import PartitionListLanguageEN_US from './en_US/PartitionListLanguage.json'

import PartitionModalEN_GB from './en_GB/PartitionModal.json'
import PartitionModalEN_US from './en_US/PartitionModal.json'

import PasswordChangeLanguageEN_GB from './en_GB/PasswordChangeLanguage.json'
import PasswordChangeLanguageEN_US from './en_US/PasswordChangeLanguage.json'

import PasswordTextInputEN_GB from './en_GB/PasswordTextInput.json'
import PasswordTextInputEN_US from './en_US/PasswordTextInput.json'

import PermissionsLanguageEN_GB from './en_GB/PermissionsLanguage.json'
import PermissionsLanguageEN_US from './en_US/PermissionsLanguage.json'

import PresenceEN_GB from './en_GB/Presence.json'
import PresenceEN_US from './en_US/Presence.json'

import PreviewEN_GB from './en_GB/Preview.json'
import PreviewEN_US from './en_US/Preview.json'

import PrintOutputEN_GB from './en_GB/PrintOutput.json'
import PrintOutputEN_US from './en_US/PrintOutput.json'

import ProvisioningEN_GB from './en_GB/Provisioning.json'
import ProvisioningEN_US from './en_US/Provisioning.json'

import RangeComboLanguageEN_GB from './en_GB/RangeComboLanguage.json'
import RangeComboLanguageEN_US from './en_US/RangeComboLanguage.json'

import RecordingListLanguageEN_GB from './en_GB/RecordingListLanguage.json'
import RecordingListLanguageEN_US from './en_US/RecordingListLanguage.json'

import ReportContentRowsSettingsLanguageEN_GB from './en_GB/ReportContentRowsSettingsLanguage.json'
import ReportContentRowsSettingsLanguageEN_US from './en_US/ReportContentRowsSettingsLanguage.json'

import ReportIntervalLanguageEN_GB from './en_GB/ReportIntervalLanguage.json'
import ReportIntervalLanguageEN_US from './en_US/ReportIntervalLanguage.json'

import ReportOptionsEN_GB from './en_GB/ReportOptions.json'
import ReportOptionsEN_US from './en_US/ReportOptions.json'

import ReportPortalInfoEN_GB from './en_GB/ReportPortalInfo.json'
import ReportPortalInfoEN_US from './en_US/ReportPortalInfo.json'

import ReportSchedulingEN_GB from './en_GB/ReportScheduling.json'
import ReportSchedulingEN_US from './en_US/ReportScheduling.json'

import ReportSchedulingEmailsEN_GB from './en_GB/ReportSchedulingEmails.json'
import ReportSchedulingEmailsEN_US from './en_US/ReportSchedulingEmails.json'

import ReportTypesEN_GB from './en_GB/ReportTypes.json'
import ReportTypesEN_US from './en_US/ReportTypes.json'

import ReportingDefaultReportSetsEN_GB from './en_GB/ReportingDefaultReportSets.json'
import ReportingDefaultReportSetsEN_US from './en_US/ReportingDefaultReportSets.json'

import ReportingLanguageEN_GB from './en_GB/ReportingLanguage.json'
import ReportingLanguageEN_US from './en_US/ReportingLanguage.json'

import ReportingMenuLanguageEN_GB from './en_GB/ReportingMenuLanguage.json'
import ReportingMenuLanguageEN_US from './en_US/ReportingMenuLanguage.json'

import ReportsFilterDeviceFilterEN_GB from './en_GB/ReportsFilterDeviceFilter.json'
import ReportsFilterDeviceFilterEN_US from './en_US/ReportsFilterDeviceFilter.json'

import RichTextEditorEN_GB from './en_GB/RichTextEditor.json'
import RichTextEditorEN_US from './en_US/RichTextEditor.json'

import RoleLanguageEN_GB from './en_GB/RoleLanguage.json'
import RoleLanguageEN_US from './en_US/RoleLanguage.json'

import RouterEN_GB from './en_GB/Router.json'
import RouterEN_US from './en_US/Router.json'

import RowOptionsEN_GB from './en_GB/RowOptions.json'
import RowOptionsEN_US from './en_US/RowOptions.json'

import RulesLanguageEN_GB from './en_GB/RulesLanguage.json'
import RulesLanguageEN_US from './en_US/RulesLanguage.json'

import SSOLanguageEN_GB from './en_GB/SSOLanguage.json'
import SSOLanguageEN_US from './en_US/SSOLanguage.json'

import ScheduleStatusEN_GB from './en_GB/ScheduleStatus.json'
import ScheduleStatusEN_US from './en_US/ScheduleStatus.json'

import ScopeAssignmentEN_GB from './en_GB/ScopeAssignment.json'
import ScopeAssignmentEN_US from './en_US/ScopeAssignment.json'

import ScopeFilteringEN_GB from './en_GB/ScopeFiltering.json'
import ScopeFilteringEN_US from './en_US/ScopeFiltering.json'

import SelfProvisioningEN_GB from './en_GB/SelfProvisioning.json'
import SelfProvisioningEN_US from './en_US/SelfProvisioning.json'

import ServerStatusLanguageEN_GB from './en_GB/ServerStatusLanguage.json'
import ServerStatusLanguageEN_US from './en_US/ServerStatusLanguage.json'

import ServiceLvlSettingsEN_GB from './en_GB/ServiceLvlSettings.json'
import ServiceLvlSettingsEN_US from './en_US/ServiceLvlSettings.json'

import ServiceMessagesLanguageEN_GB from './en_GB/ServiceMessagesLanguage.json'
import ServiceMessagesLanguageEN_US from './en_US/ServiceMessagesLanguage.json'

import SettingsLanguageEN_GB from './en_GB/SettingsLanguage.json'
import SettingsLanguageEN_US from './en_US/SettingsLanguage.json'

import SidebarMenuEN_GB from './en_GB/SidebarMenu.json'
import SidebarMenuEN_US from './en_US/SidebarMenu.json'

import SignInWithEN_GB from './en_GB/SignInWith.json'
import SignInWithEN_US from './en_US/SignInWith.json'

import SortListEN_GB from './en_GB/SortList.json'
import SortListEN_US from './en_US/SortList.json'

import StaticAgentControlsEN_GB from './en_GB/StaticAgentControls.json'
import StaticAgentControlsEN_US from './en_US/StaticAgentControls.json'

import StatisticAlarmEN_GB from './en_GB/StatisticAlarm.json'
import StatisticAlarmEN_US from './en_US/StatisticAlarm.json'

import StatisticCalculationsEN_GB from './en_GB/StatisticCalculations.json'
import StatisticCalculationsEN_US from './en_US/StatisticCalculations.json'

import StatusChangeEN_GB from './en_GB/StatusChange.json'
import StatusChangeEN_US from './en_US/StatusChange.json'

import TalkTimeEN_GB from './en_GB/TalkTime.json'
import TalkTimeEN_US from './en_US/TalkTime.json'

import TeamsAuthEN_GB from './en_GB/TeamsAuth.json'
import TeamsAuthEN_US from './en_US/TeamsAuth.json'

import TelModuleStatusListLanguageEN_GB from './en_GB/TelModuleStatusListLanguage.json'
import TelModuleStatusListLanguageEN_US from './en_US/TelModuleStatusListLanguage.json'

import TelSysConfigurationEN_GB from './en_GB/TelSysConfiguration.json'
import TelSysConfigurationEN_US from './en_US/TelSysConfiguration.json'

import TelsysListLanguageEN_GB from './en_GB/TelsysListLanguage.json'
import TelsysListLanguageEN_US from './en_US/TelsysListLanguage.json'

import TermsAndConditionsEN_GB from './en_GB/TermsAndConditions.json'
import TermsAndConditionsEN_US from './en_US/TermsAndConditions.json'

import TextInputDropDownEN_GB from './en_GB/TextInputDropDown.json'
import TextInputDropDownEN_US from './en_US/TextInputDropDown.json'

import TimeFormatsEN_GB from './en_GB/TimeFormats.json'
import TimeFormatsEN_US from './en_US/TimeFormats.json'

import TimeOptionsEN_GB from './en_GB/TimeOptions.json'
import TimeOptionsEN_US from './en_US/TimeOptions.json'

import TimezoneEN_GB from './en_GB/Timezone.json'
import TimezoneEN_US from './en_US/Timezone.json'

import TimezoneModalEN_GB from './en_GB/TimezoneModal.json'
import TimezoneModalEN_US from './en_US/TimezoneModal.json'

import UnreturnedCallsEN_GB from './en_GB/UnreturnedCalls.json'
import UnreturnedCallsEN_US from './en_US/UnreturnedCalls.json'

import UnreturnedCallsFilterEN_GB from './en_GB/UnreturnedCallsFilter.json'
import UnreturnedCallsFilterEN_US from './en_US/UnreturnedCallsFilter.json'

import UserDetailsLanguageEN_GB from './en_GB/UserDetailsLanguage.json'
import UserDetailsLanguageEN_US from './en_US/UserDetailsLanguage.json'

import UserInviteEN_GB from './en_GB/UserInvite.json'
import UserInviteEN_US from './en_US/UserInvite.json'

import UserMenuEN_GB from './en_GB/UserMenu.json'
import UserMenuEN_US from './en_US/UserMenu.json'

import UserNotificationTypesHelpEN_GB from './en_GB/UserNotificationTypesHelp.json'
import UserNotificationTypesHelpEN_US from './en_US/UserNotificationTypesHelp.json'

import UserTourEN_GB from './en_GB/UserTour.json'
import UserTourEN_US from './en_US/UserTour.json'

import UsersByExtensionEN_GB from './en_GB/UsersByExtension.json'
import UsersByExtensionEN_US from './en_US/UsersByExtension.json'

import UsersListLanguageEN_GB from './en_GB/UsersListLanguage.json'
import UsersListLanguageEN_US from './en_US/UsersListLanguage.json'

import WebexAuthLanguageEN_GB from './en_GB/WebexAuthLanguage.json'
import WebexAuthLanguageEN_US from './en_US/WebexAuthLanguage.json'

export type AvailableLanguages = {
    i18nBundles: Record<string, NamedEnumLike<unknown>>
}

export type AvailableLanguageBundle = {
    keys: NamedEnumLike<unknown>
} & AvailableLanguages['i18nBundles']

export const languageItems = {
    ACDCodesLanguage: {
        ...createLanguageEnum(ACDCodesLanguageEN_GB),
        i18nBundles: {
            en_GB: ACDCodesLanguageEN_GB,
            en_US: ACDCodesLanguageEN_US
        }
    },
    ACDDNDActivity: {
        ...createLanguageEnum(ACDDNDActivityEN_GB),
        i18nBundles: {
            en_GB: ACDDNDActivityEN_GB,
            en_US: ACDDNDActivityEN_US
        }
    },
    ACDStateThresholds: {
        ...createLanguageEnum(ACDStateThresholdsEN_GB),
        i18nBundles: {
            en_GB: ACDStateThresholdsEN_GB,
            en_US: ACDStateThresholdsEN_US
        }
    },
    ACDStatusHotKeys: {
        ...createLanguageEnum(ACDStatusHotKeysEN_GB),
        i18nBundles: {
            en_GB: ACDStatusHotKeysEN_GB,
            en_US: ACDStatusHotKeysEN_US
        }
    },
    AbandonedCallAlarm: {
        ...createLanguageEnum(AbandonedCallAlarmEN_GB),
        i18nBundles: {
            en_GB: AbandonedCallAlarmEN_GB,
            en_US: AbandonedCallAlarmEN_US
        }
    },
    AbandonedTimeStatisticLanguage: {
        ...createLanguageEnum(AbandonedTimeStatisticLanguageEN_GB),
        i18nBundles: {
            en_GB: AbandonedTimeStatisticLanguageEN_GB,
            en_US: AbandonedTimeStatisticLanguageEN_US
        }
    },
    AddUserLanguage: {
        ...createLanguageEnum(AddUserLanguageEN_GB),
        i18nBundles: {
            en_GB: AddUserLanguageEN_GB,
            en_US: AddUserLanguageEN_US
        }
    },
    AdminActionsLanguage: {
        ...createLanguageEnum(AdminActionsLanguageEN_GB),
        i18nBundles: {
            en_GB: AdminActionsLanguageEN_GB,
            en_US: AdminActionsLanguageEN_US
        }
    },
    AdminOverviewLanguage: {
        ...createLanguageEnum(AdminOverviewLanguageEN_GB),
        i18nBundles: {
            en_GB: AdminOverviewLanguageEN_GB,
            en_US: AdminOverviewLanguageEN_US
        }
    },
    AdministratorLanguage: {
        ...createLanguageEnum(AdministratorLanguageEN_GB),
        i18nBundles: {
            en_GB: AdministratorLanguageEN_GB,
            en_US: AdministratorLanguageEN_US
        }
    },
    Advanced: {
        ...createLanguageEnum(AdvancedEN_GB),
        i18nBundles: {
            en_GB: AdvancedEN_GB,
            en_US: AdvancedEN_US
        }
    },
    AgentAdvanced: {
        ...createLanguageEnum(AgentAdvancedEN_GB),
        i18nBundles: {
            en_GB: AgentAdvancedEN_GB,
            en_US: AgentAdvancedEN_US
        }
    },
    AgentDetails: {
        ...createLanguageEnum(AgentDetailsEN_GB),
        i18nBundles: {
            en_GB: AgentDetailsEN_GB,
            en_US: AgentDetailsEN_US
        }
    },
    AgentListLanguage: {
        ...createLanguageEnum(AgentListLanguageEN_GB),
        i18nBundles: {
            en_GB: AgentListLanguageEN_GB,
            en_US: AgentListLanguageEN_US
        }
    },
    AgentOmnichannel: {
        ...createLanguageEnum(AgentOmnichannelEN_GB),
        i18nBundles: {
            en_GB: AgentOmnichannelEN_GB,
            en_US: AgentOmnichannelEN_US
        }
    },
    AlarmActions: {
        ...createLanguageEnum(AlarmActionsEN_GB),
        i18nBundles: {
            en_GB: AlarmActionsEN_GB,
            en_US: AlarmActionsEN_US
        }
    },
    AnswerPerformance: {
        ...createLanguageEnum(AnswerPerformanceEN_GB),
        i18nBundles: {
            en_GB: AnswerPerformanceEN_GB,
            en_US: AnswerPerformanceEN_US
        }
    },
    ApiKeys: {
        ...createLanguageEnum(ApiKeysEN_GB),
        i18nBundles: {
            en_GB: ApiKeysEN_GB,
            en_US: ApiKeysEN_US
        }
    },
    AppMenu: {
        ...createLanguageEnum(AppMenuEN_GB),
        i18nBundles: {
            en_GB: AppMenuEN_GB,
            en_US: AppMenuEN_US
        }
    },
    Audit: {
        ...createLanguageEnum(AuditEN_GB),
        i18nBundles: {
            en_GB: AuditEN_GB,
            en_US: AuditEN_US
        }
    },
    Authentication: {
        ...createLanguageEnum(AuthenticationEN_GB),
        i18nBundles: {
            en_GB: AuthenticationEN_GB,
            en_US: AuthenticationEN_US
        }
    },
    BrandingLanguage: {
        ...createLanguageEnum(BrandingLanguageEN_GB),
        i18nBundles: {
            en_GB: BrandingLanguageEN_GB,
            en_US: BrandingLanguageEN_US
        }
    },
    BroadworksSSO: {
        ...createLanguageEnum(BroadworksSSOEN_GB),
        i18nBundles: {
            en_GB: BroadworksSSOEN_GB,
            en_US: BroadworksSSOEN_US
        }
    },
    CMECapabilities: {
        ...createLanguageEnum(CMECapabilitiesEN_GB),
        i18nBundles: {
            en_GB: CMECapabilitiesEN_GB,
            en_US: CMECapabilitiesEN_US
        }
    },
    CMEDetails: {
        ...createLanguageEnum(CMEDetailsEN_GB),
        i18nBundles: {
            en_GB: CMEDetailsEN_GB,
            en_US: CMEDetailsEN_US
        }
    },
    CRMConfigurationLanguage: {
        ...createLanguageEnum(CRMConfigurationLanguageEN_GB),
        i18nBundles: {
            en_GB: CRMConfigurationLanguageEN_GB,
            en_US: CRMConfigurationLanguageEN_US
        }
    },
    CRMModal: {
        ...createLanguageEnum(CRMModalEN_GB),
        i18nBundles: {
            en_GB: CRMModalEN_GB,
            en_US: CRMModalEN_US
        }
    },
    CSVExportFormat: {
        ...createLanguageEnum(CSVExportFormatEN_GB),
        i18nBundles: {
            en_GB: CSVExportFormatEN_GB,
            en_US: CSVExportFormatEN_US
        }
    },
    CXRecordLanguage: {
        ...createLanguageEnum(CXRecordLanguageEN_GB),
        i18nBundles: {
            en_GB: CXRecordLanguageEN_GB,
            en_US: CXRecordLanguageEN_US
        }
    },
    CXScoreLanguage: {
        ...createLanguageEnum(CXScoreLanguageEN_GB),
        i18nBundles: {
            en_GB: CXScoreLanguageEN_GB,
            en_US: CXScoreLanguageEN_US
        }
    },
    CallControlErrors: {
        ...createLanguageEnum(CallControlErrorsEN_GB),
        i18nBundles: {
            en_GB: CallControlErrorsEN_GB,
            en_US: CallControlErrorsEN_US
        }
    },
    CallDetails: {
        ...createLanguageEnum(CallDetailsEN_GB),
        i18nBundles: {
            en_GB: CallDetailsEN_GB,
            en_US: CallDetailsEN_US
        }
    },
    CallMovementFiltering: {
        ...createLanguageEnum(CallMovementFilteringEN_GB),
        i18nBundles: {
            en_GB: CallMovementFilteringEN_GB,
            en_US: CallMovementFilteringEN_US
        }
    },
    CallRecIntegration: {
        ...createLanguageEnum(CallRecIntegrationEN_GB),
        i18nBundles: {
            en_GB: CallRecIntegrationEN_GB,
            en_US: CallRecIntegrationEN_US
        }
    },
    CallRecording: {
        ...createLanguageEnum(CallRecordingEN_GB),
        i18nBundles: {
            en_GB: CallRecordingEN_GB,
            en_US: CallRecordingEN_US
        }
    },
    CallStateThresholds: {
        ...createLanguageEnum(CallStateThresholdsEN_GB),
        i18nBundles: {
            en_GB: CallStateThresholdsEN_GB,
            en_US: CallStateThresholdsEN_US
        }
    },
    CallTargetting: {
        ...createLanguageEnum(CallTargettingEN_GB),
        i18nBundles: {
            en_GB: CallTargettingEN_GB,
            en_US: CallTargettingEN_US
        }
    },
    ChangeLangLanguage: {
        ...createLanguageEnum(ChangeLangLanguageEN_GB),
        i18nBundles: {
            en_GB: ChangeLangLanguageEN_GB,
            en_US: ChangeLangLanguageEN_US
        }
    },
    ChangeLayout: {
        ...createLanguageEnum(ChangeLayoutEN_GB),
        i18nBundles: {
            en_GB: ChangeLayoutEN_GB,
            en_US: ChangeLayoutEN_US
        }
    },
    ChangeUserAgentLanguage: {
        ...createLanguageEnum(ChangeUserAgentLanguageEN_GB),
        i18nBundles: {
            en_GB: ChangeUserAgentLanguageEN_GB,
            en_US: ChangeUserAgentLanguageEN_US
        }
    },
    ChartProviderOptions: {
        ...createLanguageEnum(ChartProviderOptionsEN_GB),
        i18nBundles: {
            en_GB: ChartProviderOptionsEN_GB,
            en_US: ChartProviderOptionsEN_US
        }
    },
    ChartStyleOptions: {
        ...createLanguageEnum(ChartStyleOptionsEN_GB),
        i18nBundles: {
            en_GB: ChartStyleOptionsEN_GB,
            en_US: ChartStyleOptionsEN_US
        }
    },
    ClientConfigurationLanguage: {
        ...createLanguageEnum(ClientConfigurationLanguageEN_GB),
        i18nBundles: {
            en_GB: ClientConfigurationLanguageEN_GB,
            en_US: ClientConfigurationLanguageEN_US
        }
    },
    ClientConfigurationModalLanguage: {
        ...createLanguageEnum(ClientConfigurationModalLanguageEN_GB),
        i18nBundles: {
            en_GB: ClientConfigurationModalLanguageEN_GB,
            en_US: ClientConfigurationModalLanguageEN_US
        }
    },
    CmeListLanguage: {
        ...createLanguageEnum(CmeListLanguageEN_GB),
        i18nBundles: {
            en_GB: CmeListLanguageEN_GB,
            en_US: CmeListLanguageEN_US
        }
    },
    CodeAddModify: {
        ...createLanguageEnum(CodeAddModifyEN_GB),
        i18nBundles: {
            en_GB: CodeAddModifyEN_GB,
            en_US: CodeAddModifyEN_US
        }
    },
    CodeListLanguage: {
        ...createLanguageEnum(CodeListLanguageEN_GB),
        i18nBundles: {
            en_GB: CodeListLanguageEN_GB,
            en_US: CodeListLanguageEN_US
        }
    },
    ComboBox: {
        ...createLanguageEnum(ComboBoxEN_GB),
        i18nBundles: {
            en_GB: ComboBoxEN_GB,
            en_US: ComboBoxEN_US
        }
    },
    CommonAdmin: {
        ...createLanguageEnum(CommonAdminEN_GB),
        i18nBundles: {
            en_GB: CommonAdminEN_GB,
            en_US: CommonAdminEN_US
        }
    },
    ConfigChangeLogListLanguage: {
        ...createLanguageEnum(ConfigChangeLogListLanguageEN_GB),
        i18nBundles: {
            en_GB: ConfigChangeLogListLanguageEN_GB,
            en_US: ConfigChangeLogListLanguageEN_US
        }
    },
    ConfigureAgents: {
        ...createLanguageEnum(ConfigureAgentsEN_GB),
        i18nBundles: {
            en_GB: ConfigureAgentsEN_GB,
            en_US: ConfigureAgentsEN_US
        }
    },
    ConfigureReport: {
        ...createLanguageEnum(ConfigureReportEN_GB),
        i18nBundles: {
            en_GB: ConfigureReportEN_GB,
            en_US: ConfigureReportEN_US
        }
    },
    ContentRestriction: {
        ...createLanguageEnum(ContentRestrictionEN_GB),
        i18nBundles: {
            en_GB: ContentRestrictionEN_GB,
            en_US: ContentRestrictionEN_US
        }
    },
    CookieConsent: {
        ...createLanguageEnum(CookieConsentEN_GB),
        i18nBundles: {
            en_GB: CookieConsentEN_GB,
            en_US: CookieConsentEN_US
        }
    },
    Currency: {
        ...createLanguageEnum(CurrencyEN_GB),
        i18nBundles: {
            en_GB: CurrencyEN_GB,
            en_US: CurrencyEN_US
        }
    },
    CurrencyDisplayFormat: {
        ...createLanguageEnum(CurrencyDisplayFormatEN_GB),
        i18nBundles: {
            en_GB: CurrencyDisplayFormatEN_GB,
            en_US: CurrencyDisplayFormatEN_US
        }
    },
    CustomSettings: {
        ...createLanguageEnum(CustomSettingsEN_GB),
        i18nBundles: {
            en_GB: CustomSettingsEN_GB,
            en_US: CustomSettingsEN_US
        }
    },
    CustomiseRole: {
        ...createLanguageEnum(CustomiseRoleEN_GB),
        i18nBundles: {
            en_GB: CustomiseRoleEN_GB,
            en_US: CustomiseRoleEN_US
        }
    },
    CxiLicenceTypes: {
        ...createLanguageEnum(CxiLicenceTypesEN_GB),
        i18nBundles: {
            en_GB: CxiLicenceTypesEN_GB,
            en_US: CxiLicenceTypesEN_US
        }
    },
    DarkMode: {
        ...createLanguageEnum(DarkModeEN_GB),
        i18nBundles: {
            en_GB: DarkModeEN_GB,
            en_US: DarkModeEN_US
        }
    },
    DashboardDisplaySettings: {
        ...createLanguageEnum(DashboardDisplaySettingsEN_GB),
        i18nBundles: {
            en_GB: DashboardDisplaySettingsEN_GB,
            en_US: DashboardDisplaySettingsEN_US
        }
    },
    DashboardList: {
        ...createLanguageEnum(DashboardListEN_GB),
        i18nBundles: {
            en_GB: DashboardListEN_GB,
            en_US: DashboardListEN_US
        }
    },
    DashboardOptions: {
        ...createLanguageEnum(DashboardOptionsEN_GB),
        i18nBundles: {
            en_GB: DashboardOptionsEN_GB,
            en_US: DashboardOptionsEN_US
        }
    },
    DatabaseLanguage: {
        ...createLanguageEnum(DatabaseLanguageEN_GB),
        i18nBundles: {
            en_GB: DatabaseLanguageEN_GB,
            en_US: DatabaseLanguageEN_US
        }
    },
    Date: {
        ...createLanguageEnum(DateEN_GB),
        i18nBundles: {
            en_GB: DateEN_GB,
            en_US: DateEN_US
        }
    },
    DateTime: {
        ...createLanguageEnum(DateTimeEN_GB),
        i18nBundles: {
            en_GB: DateTimeEN_GB,
            en_US: DateTimeEN_US
        }
    },
    DaysOfTheWeek: {
        ...createLanguageEnum(DaysOfTheWeekEN_GB),
        i18nBundles: {
            en_GB: DaysOfTheWeekEN_GB,
            en_US: DaysOfTheWeekEN_US
        }
    },
    DeviceFiltering: {
        ...createLanguageEnum(DeviceFilteringEN_GB),
        i18nBundles: {
            en_GB: DeviceFilteringEN_GB,
            en_US: DeviceFilteringEN_US
        }
    },
    DeviceListLanguage: {
        ...createLanguageEnum(DeviceListLanguageEN_GB),
        i18nBundles: {
            en_GB: DeviceListLanguageEN_GB,
            en_US: DeviceListLanguageEN_US
        }
    },
    DeviceModal: {
        ...createLanguageEnum(DeviceModalEN_GB),
        i18nBundles: {
            en_GB: DeviceModalEN_GB,
            en_US: DeviceModalEN_US
        }
    },
    DeviceTypesLanguage: {
        ...createLanguageEnum(DeviceTypesLanguageEN_GB),
        i18nBundles: {
            en_GB: DeviceTypesLanguageEN_GB,
            en_US: DeviceTypesLanguageEN_US
        }
    },
    DirectoryListLanguage: {
        ...createLanguageEnum(DirectoryListLanguageEN_GB),
        i18nBundles: {
            en_GB: DirectoryListLanguageEN_GB,
            en_US: DirectoryListLanguageEN_US
        }
    },
    DirectoryModal: {
        ...createLanguageEnum(DirectoryModalEN_GB),
        i18nBundles: {
            en_GB: DirectoryModalEN_GB,
            en_US: DirectoryModalEN_US
        }
    },
    DisplayOptions: {
        ...createLanguageEnum(DisplayOptionsEN_GB),
        i18nBundles: {
            en_GB: DisplayOptionsEN_GB,
            en_US: DisplayOptionsEN_US
        }
    },
    DisplaySettings: {
        ...createLanguageEnum(DisplaySettingsEN_GB),
        i18nBundles: {
            en_GB: DisplaySettingsEN_GB,
            en_US: DisplaySettingsEN_US
        }
    },
    DisplaySwitching: {
        ...createLanguageEnum(DisplaySwitchingEN_GB),
        i18nBundles: {
            en_GB: DisplaySwitchingEN_GB,
            en_US: DisplaySwitchingEN_US
        }
    },
    DisplayedAsOptions: {
        ...createLanguageEnum(DisplayedAsOptionsEN_GB),
        i18nBundles: {
            en_GB: DisplayedAsOptionsEN_GB,
            en_US: DisplayedAsOptionsEN_US
        }
    },
    DocumentViewer: {
        ...createLanguageEnum(DocumentViewerEN_GB),
        i18nBundles: {
            en_GB: DocumentViewerEN_GB,
            en_US: DocumentViewerEN_US
        }
    },
    DomainProfile: {
        ...createLanguageEnum(DomainProfileEN_GB),
        i18nBundles: {
            en_GB: DomainProfileEN_GB,
            en_US: DomainProfileEN_US
        }
    },
    DurationFiltering: {
        ...createLanguageEnum(DurationFilteringEN_GB),
        i18nBundles: {
            en_GB: DurationFilteringEN_GB,
            en_US: DurationFilteringEN_US
        }
    },
    ErrorLanguage: {
        ...createLanguageEnum(ErrorLanguageEN_GB),
        i18nBundles: {
            en_GB: ErrorLanguageEN_GB,
            en_US: ErrorLanguageEN_US
        }
    },
    Estate: {
        ...createLanguageEnum(EstateEN_GB),
        i18nBundles: {
            en_GB: EstateEN_GB,
            en_US: EstateEN_US
        }
    },
    ExtensionEndpoint: {
        ...createLanguageEnum(ExtensionEndpointEN_GB),
        i18nBundles: {
            en_GB: ExtensionEndpointEN_GB,
            en_US: ExtensionEndpointEN_US
        }
    },
    FieldsList: {
        ...createLanguageEnum(FieldsListEN_GB),
        i18nBundles: {
            en_GB: FieldsListEN_GB,
            en_US: FieldsListEN_US
        }
    },
    FieldsTab: {
        ...createLanguageEnum(FieldsTabEN_GB),
        i18nBundles: {
            en_GB: FieldsTabEN_GB,
            en_US: FieldsTabEN_US
        }
    },
    FileUploadLanguage: {
        ...createLanguageEnum(FileUploadLanguageEN_GB),
        i18nBundles: {
            en_GB: FileUploadLanguageEN_GB,
            en_US: FileUploadLanguageEN_US
        }
    },
    ForgotPasswordLanguage: {
        ...createLanguageEnum(ForgotPasswordLanguageEN_GB),
        i18nBundles: {
            en_GB: ForgotPasswordLanguageEN_GB,
            en_US: ForgotPasswordLanguageEN_US
        }
    },
    Format: {
        ...createLanguageEnum(FormatEN_GB),
        i18nBundles: {
            en_GB: FormatEN_GB,
            en_US: FormatEN_US
        }
    },
    GenericAdminFilterLanguage: {
        ...createLanguageEnum(GenericAdminFilterLanguageEN_GB),
        i18nBundles: {
            en_GB: GenericAdminFilterLanguageEN_GB,
            en_US: GenericAdminFilterLanguageEN_US
        }
    },
    GenericAdminListLanguage: {
        ...createLanguageEnum(GenericAdminListLanguageEN_GB),
        i18nBundles: {
            en_GB: GenericAdminListLanguageEN_GB,
            en_US: GenericAdminListLanguageEN_US
        }
    },
    GenericFooter: {
        ...createLanguageEnum(GenericFooterEN_GB),
        i18nBundles: {
            en_GB: GenericFooterEN_GB,
            en_US: GenericFooterEN_US
        }
    },
    GenericModal: {
        ...createLanguageEnum(GenericModalEN_GB),
        i18nBundles: {
            en_GB: GenericModalEN_GB,
            en_US: GenericModalEN_US
        }
    },
    GenericRuleLanguage: {
        ...createLanguageEnum(GenericRuleLanguageEN_GB),
        i18nBundles: {
            en_GB: GenericRuleLanguageEN_GB,
            en_US: GenericRuleLanguageEN_US
        }
    },
    GenericScopeTab: {
        ...createLanguageEnum(GenericScopeTabEN_GB),
        i18nBundles: {
            en_GB: GenericScopeTabEN_GB,
            en_US: GenericScopeTabEN_US
        }
    },
    HeaderSidebar: {
        ...createLanguageEnum(HeaderSidebarEN_GB),
        i18nBundles: {
            en_GB: HeaderSidebarEN_GB,
            en_US: HeaderSidebarEN_US
        }
    },
    InboundStatSettings: {
        ...createLanguageEnum(InboundStatSettingsEN_GB),
        i18nBundles: {
            en_GB: InboundStatSettingsEN_GB,
            en_US: InboundStatSettingsEN_US
        }
    },
    InsightsDashboardLanguage: {
        ...createLanguageEnum(InsightsDashboardLanguageEN_GB),
        i18nBundles: {
            en_GB: InsightsDashboardLanguageEN_GB,
            en_US: InsightsDashboardLanguageEN_US
        }
    },
    InsightsHub: {
        ...createLanguageEnum(InsightsHubEN_GB),
        i18nBundles: {
            en_GB: InsightsHubEN_GB,
            en_US: InsightsHubEN_US
        }
    },
    LanguageBulkInsertUsers: {
        ...createLanguageEnum(LanguageBulkInsertUsersEN_GB),
        i18nBundles: {
            en_GB: LanguageBulkInsertUsersEN_GB,
            en_US: LanguageBulkInsertUsersEN_US
        }
    },
    LanguageBulkUploadDirectoryEntries: {
        ...createLanguageEnum(LanguageBulkUploadDirectoryEntriesEN_GB),
        i18nBundles: {
            en_GB: LanguageBulkUploadDirectoryEntriesEN_GB,
            en_US: LanguageBulkUploadDirectoryEntriesEN_US
        }
    },
    LanguageCME: {
        ...createLanguageEnum(LanguageCMEEN_GB),
        i18nBundles: {
            en_GB: LanguageCMEEN_GB,
            en_US: LanguageCMEEN_US
        }
    },
    LanguageDataTable: {
        ...createLanguageEnum(LanguageDataTableEN_GB),
        i18nBundles: {
            en_GB: LanguageDataTableEN_GB,
            en_US: LanguageDataTableEN_US
        }
    },
    LanguageErrorCodes: {
        ...createLanguageEnum(LanguageErrorCodesEN_GB),
        i18nBundles: {
            en_GB: LanguageErrorCodesEN_GB,
            en_US: LanguageErrorCodesEN_US
        }
    },
    LanguageErrors: {
        ...createLanguageEnum(LanguageErrorsEN_GB),
        i18nBundles: {
            en_GB: LanguageErrorsEN_GB,
            en_US: LanguageErrorsEN_US
        }
    },
    LanguageFallbackNav: {
        ...createLanguageEnum(LanguageFallbackNavEN_GB),
        i18nBundles: {
            en_GB: LanguageFallbackNavEN_GB,
            en_US: LanguageFallbackNavEN_US
        }
    },
    LanguageGeneral: {
        ...createLanguageEnum(LanguageGeneralEN_GB),
        i18nBundles: {
            en_GB: LanguageGeneralEN_GB,
            en_US: LanguageGeneralEN_US
        }
    },
    LanguageLogFileDownload: {
        ...createLanguageEnum(LanguageLogFileDownloadEN_GB),
        i18nBundles: {
            en_GB: LanguageLogFileDownloadEN_GB,
            en_US: LanguageLogFileDownloadEN_US
        }
    },
    LanguageMainMenu: {
        ...createLanguageEnum(LanguageMainMenuEN_GB),
        i18nBundles: {
            en_GB: LanguageMainMenuEN_GB,
            en_US: LanguageMainMenuEN_US
        }
    },
    LanguageMainNavigation: {
        ...createLanguageEnum(LanguageMainNavigationEN_GB),
        i18nBundles: {
            en_GB: LanguageMainNavigationEN_GB,
            en_US: LanguageMainNavigationEN_US
        }
    },
    LanguageMyReportList: {
        ...createLanguageEnum(LanguageMyReportListEN_GB),
        i18nBundles: {
            en_GB: LanguageMyReportListEN_GB,
            en_US: LanguageMyReportListEN_US
        }
    },
    LanguageNewUserTutorial: {
        ...createLanguageEnum(LanguageNewUserTutorialEN_GB),
        i18nBundles: {
            en_GB: LanguageNewUserTutorialEN_GB,
            en_US: LanguageNewUserTutorialEN_US
        }
    },
    LanguagePrompt: {
        ...createLanguageEnum(LanguagePromptEN_GB),
        i18nBundles: {
            en_GB: LanguagePromptEN_GB,
            en_US: LanguagePromptEN_US
        }
    },
    LanguageSnackbar: {
        ...createLanguageEnum(LanguageSnackbarEN_GB),
        i18nBundles: {
            en_GB: LanguageSnackbarEN_GB,
            en_US: LanguageSnackbarEN_US
        }
    },
    LicenceManagementPageLanguage: {
        ...createLanguageEnum(LicenceManagementPageLanguageEN_GB),
        i18nBundles: {
            en_GB: LicenceManagementPageLanguageEN_GB,
            en_US: LicenceManagementPageLanguageEN_US
        }
    },
    LicenseManagement: {
        ...createLanguageEnum(LicenseManagementEN_GB),
        i18nBundles: {
            en_GB: LicenseManagementEN_GB,
            en_US: LicenseManagementEN_US
        }
    },
    LicenseManagementLanguage: {
        ...createLanguageEnum(LicenseManagementLanguageEN_GB),
        i18nBundles: {
            en_GB: LicenseManagementLanguageEN_GB,
            en_US: LicenseManagementLanguageEN_US
        }
    },
    LinkInputLanguage: {
        ...createLanguageEnum(LinkInputLanguageEN_GB),
        i18nBundles: {
            en_GB: LinkInputLanguageEN_GB,
            en_US: LinkInputLanguageEN_US
        }
    },
    LocationalFiltering: {
        ...createLanguageEnum(LocationalFilteringEN_GB),
        i18nBundles: {
            en_GB: LocationalFilteringEN_GB,
            en_US: LocationalFilteringEN_US
        }
    },
    LogManagementListLanguage: {
        ...createLanguageEnum(LogManagementListLanguageEN_GB),
        i18nBundles: {
            en_GB: LogManagementListLanguageEN_GB,
            en_US: LogManagementListLanguageEN_US
        }
    },
    LoggingSettingsLanguage: {
        ...createLanguageEnum(LoggingSettingsLanguageEN_GB),
        i18nBundles: {
            en_GB: LoggingSettingsLanguageEN_GB,
            en_US: LoggingSettingsLanguageEN_US
        }
    },
    MFALanguage: {
        ...createLanguageEnum(MFALanguageEN_GB),
        i18nBundles: {
            en_GB: MFALanguageEN_GB,
            en_US: MFALanguageEN_US
        }
    },
    ManageCustomRoles: {
        ...createLanguageEnum(ManageCustomRolesEN_GB),
        i18nBundles: {
            en_GB: ManageCustomRolesEN_GB,
            en_US: ManageCustomRolesEN_US
        }
    },
    ManageQueues: {
        ...createLanguageEnum(ManageQueuesEN_GB),
        i18nBundles: {
            en_GB: ManageQueuesEN_GB,
            en_US: ManageQueuesEN_US
        }
    },
    MediaPlayer: {
        ...createLanguageEnum(MediaPlayerEN_GB),
        i18nBundles: {
            en_GB: MediaPlayerEN_GB,
            en_US: MediaPlayerEN_US
        }
    },
    MessagesLanguage: {
        ...createLanguageEnum(MessagesLanguageEN_GB),
        i18nBundles: {
            en_GB: MessagesLanguageEN_GB,
            en_US: MessagesLanguageEN_US
        }
    },
    MicrosoftSSO: {
        ...createLanguageEnum(MicrosoftSSOEN_GB),
        i18nBundles: {
            en_GB: MicrosoftSSOEN_GB,
            en_US: MicrosoftSSOEN_US
        }
    },
    MiscellaneousFiltering: {
        ...createLanguageEnum(MiscellaneousFilteringEN_GB),
        i18nBundles: {
            en_GB: MiscellaneousFilteringEN_GB,
            en_US: MiscellaneousFilteringEN_US
        }
    },
    MonetaryCallAssignments: {
        ...createLanguageEnum(MonetaryCallAssignmentsEN_GB),
        i18nBundles: {
            en_GB: MonetaryCallAssignmentsEN_GB,
            en_US: MonetaryCallAssignmentsEN_US
        }
    },
    NotificationsLanguage: {
        ...createLanguageEnum(NotificationsLanguageEN_GB),
        i18nBundles: {
            en_GB: NotificationsLanguageEN_GB,
            en_US: NotificationsLanguageEN_US
        }
    },
    NotificationsLanguageModal: {
        ...createLanguageEnum(NotificationsLanguageModalEN_GB),
        i18nBundles: {
            en_GB: NotificationsLanguageModalEN_GB,
            en_US: NotificationsLanguageModalEN_US
        }
    },
    OAuthButton: {
        ...createLanguageEnum(OAuthButtonEN_GB),
        i18nBundles: {
            en_GB: OAuthButtonEN_GB,
            en_US: OAuthButtonEN_US
        }
    },
    PaginatedList: {
        ...createLanguageEnum(PaginatedListEN_GB),
        i18nBundles: {
            en_GB: PaginatedListEN_GB,
            en_US: PaginatedListEN_US
        }
    },
    PartitionListLanguage: {
        ...createLanguageEnum(PartitionListLanguageEN_GB),
        i18nBundles: {
            en_GB: PartitionListLanguageEN_GB,
            en_US: PartitionListLanguageEN_US
        }
    },
    PartitionModal: {
        ...createLanguageEnum(PartitionModalEN_GB),
        i18nBundles: {
            en_GB: PartitionModalEN_GB,
            en_US: PartitionModalEN_US
        }
    },
    PasswordChangeLanguage: {
        ...createLanguageEnum(PasswordChangeLanguageEN_GB),
        i18nBundles: {
            en_GB: PasswordChangeLanguageEN_GB,
            en_US: PasswordChangeLanguageEN_US
        }
    },
    PasswordTextInput: {
        ...createLanguageEnum(PasswordTextInputEN_GB),
        i18nBundles: {
            en_GB: PasswordTextInputEN_GB,
            en_US: PasswordTextInputEN_US
        }
    },
    PermissionsLanguage: {
        ...createLanguageEnum(PermissionsLanguageEN_GB),
        i18nBundles: {
            en_GB: PermissionsLanguageEN_GB,
            en_US: PermissionsLanguageEN_US
        }
    },
    Presence: {
        ...createLanguageEnum(PresenceEN_GB),
        i18nBundles: {
            en_GB: PresenceEN_GB,
            en_US: PresenceEN_US
        }
    },
    Preview: {
        ...createLanguageEnum(PreviewEN_GB),
        i18nBundles: {
            en_GB: PreviewEN_GB,
            en_US: PreviewEN_US
        }
    },
    PrintOutput: {
        ...createLanguageEnum(PrintOutputEN_GB),
        i18nBundles: {
            en_GB: PrintOutputEN_GB,
            en_US: PrintOutputEN_US
        }
    },
    Provisioning: {
        ...createLanguageEnum(ProvisioningEN_GB),
        i18nBundles: {
            en_GB: ProvisioningEN_GB,
            en_US: ProvisioningEN_US
        }
    },
    RangeComboLanguage: {
        ...createLanguageEnum(RangeComboLanguageEN_GB),
        i18nBundles: {
            en_GB: RangeComboLanguageEN_GB,
            en_US: RangeComboLanguageEN_US
        }
    },
    RecordingListLanguage: {
        ...createLanguageEnum(RecordingListLanguageEN_GB),
        i18nBundles: {
            en_GB: RecordingListLanguageEN_GB,
            en_US: RecordingListLanguageEN_US
        }
    },
    ReportContentRowsSettingsLanguage: {
        ...createLanguageEnum(ReportContentRowsSettingsLanguageEN_GB),
        i18nBundles: {
            en_GB: ReportContentRowsSettingsLanguageEN_GB,
            en_US: ReportContentRowsSettingsLanguageEN_US
        }
    },
    ReportIntervalLanguage: {
        ...createLanguageEnum(ReportIntervalLanguageEN_GB),
        i18nBundles: {
            en_GB: ReportIntervalLanguageEN_GB,
            en_US: ReportIntervalLanguageEN_US
        }
    },
    ReportOptions: {
        ...createLanguageEnum(ReportOptionsEN_GB),
        i18nBundles: {
            en_GB: ReportOptionsEN_GB,
            en_US: ReportOptionsEN_US
        }
    },
    ReportPortalInfo: {
        ...createLanguageEnum(ReportPortalInfoEN_GB),
        i18nBundles: {
            en_GB: ReportPortalInfoEN_GB,
            en_US: ReportPortalInfoEN_US
        }
    },
    ReportScheduling: {
        ...createLanguageEnum(ReportSchedulingEN_GB),
        i18nBundles: {
            en_GB: ReportSchedulingEN_GB,
            en_US: ReportSchedulingEN_US
        }
    },
    ReportSchedulingEmails: {
        ...createLanguageEnum(ReportSchedulingEmailsEN_GB),
        i18nBundles: {
            en_GB: ReportSchedulingEmailsEN_GB,
            en_US: ReportSchedulingEmailsEN_US
        }
    },
    ReportTypes: {
        ...createLanguageEnum(ReportTypesEN_GB),
        i18nBundles: {
            en_GB: ReportTypesEN_GB,
            en_US: ReportTypesEN_US
        }
    },
    ReportingDefaultReportSets: {
        ...createLanguageEnum(ReportingDefaultReportSetsEN_GB),
        i18nBundles: {
            en_GB: ReportingDefaultReportSetsEN_GB,
            en_US: ReportingDefaultReportSetsEN_US
        }
    },
    ReportingLanguage: {
        ...createLanguageEnum(ReportingLanguageEN_GB),
        i18nBundles: {
            en_GB: ReportingLanguageEN_GB,
            en_US: ReportingLanguageEN_US
        }
    },
    ReportingMenuLanguage: {
        ...createLanguageEnum(ReportingMenuLanguageEN_GB),
        i18nBundles: {
            en_GB: ReportingMenuLanguageEN_GB,
            en_US: ReportingMenuLanguageEN_US
        }
    },
    ReportsFilterDeviceFilter: {
        ...createLanguageEnum(ReportsFilterDeviceFilterEN_GB),
        i18nBundles: {
            en_GB: ReportsFilterDeviceFilterEN_GB,
            en_US: ReportsFilterDeviceFilterEN_US
        }
    },
    RichTextEditor: {
        ...createLanguageEnum(RichTextEditorEN_GB),
        i18nBundles: {
            en_GB: RichTextEditorEN_GB,
            en_US: RichTextEditorEN_US
        }
    },
    RoleLanguage: {
        ...createLanguageEnum(RoleLanguageEN_GB),
        i18nBundles: {
            en_GB: RoleLanguageEN_GB,
            en_US: RoleLanguageEN_US
        }
    },
    Router: {
        ...createLanguageEnum(RouterEN_GB),
        i18nBundles: {
            en_GB: RouterEN_GB,
            en_US: RouterEN_US
        }
    },
    RowOptions: {
        ...createLanguageEnum(RowOptionsEN_GB),
        i18nBundles: {
            en_GB: RowOptionsEN_GB,
            en_US: RowOptionsEN_US
        }
    },
    RulesLanguage: {
        ...createLanguageEnum(RulesLanguageEN_GB),
        i18nBundles: {
            en_GB: RulesLanguageEN_GB,
            en_US: RulesLanguageEN_US
        }
    },
    SSOLanguage: {
        ...createLanguageEnum(SSOLanguageEN_GB),
        i18nBundles: {
            en_GB: SSOLanguageEN_GB,
            en_US: SSOLanguageEN_US
        }
    },
    ScheduleStatus: {
        ...createLanguageEnum(ScheduleStatusEN_GB),
        i18nBundles: {
            en_GB: ScheduleStatusEN_GB,
            en_US: ScheduleStatusEN_US
        }
    },
    ScopeAssignment: {
        ...createLanguageEnum(ScopeAssignmentEN_GB),
        i18nBundles: {
            en_GB: ScopeAssignmentEN_GB,
            en_US: ScopeAssignmentEN_US
        }
    },
    ScopeFiltering: {
        ...createLanguageEnum(ScopeFilteringEN_GB),
        i18nBundles: {
            en_GB: ScopeFilteringEN_GB,
            en_US: ScopeFilteringEN_US
        }
    },
    SelfProvisioning: {
        ...createLanguageEnum(SelfProvisioningEN_GB),
        i18nBundles: {
            en_GB: SelfProvisioningEN_GB,
            en_US: SelfProvisioningEN_US
        }
    },
    ServerStatusLanguage: {
        ...createLanguageEnum(ServerStatusLanguageEN_GB),
        i18nBundles: {
            en_GB: ServerStatusLanguageEN_GB,
            en_US: ServerStatusLanguageEN_US
        }
    },
    ServiceLvlSettings: {
        ...createLanguageEnum(ServiceLvlSettingsEN_GB),
        i18nBundles: {
            en_GB: ServiceLvlSettingsEN_GB,
            en_US: ServiceLvlSettingsEN_US
        }
    },
    ServiceMessagesLanguage: {
        ...createLanguageEnum(ServiceMessagesLanguageEN_GB),
        i18nBundles: {
            en_GB: ServiceMessagesLanguageEN_GB,
            en_US: ServiceMessagesLanguageEN_US
        }
    },
    SettingsLanguage: {
        ...createLanguageEnum(SettingsLanguageEN_GB),
        i18nBundles: {
            en_GB: SettingsLanguageEN_GB,
            en_US: SettingsLanguageEN_US
        }
    },
    SidebarMenu: {
        ...createLanguageEnum(SidebarMenuEN_GB),
        i18nBundles: {
            en_GB: SidebarMenuEN_GB,
            en_US: SidebarMenuEN_US
        }
    },
    SignInWith: {
        ...createLanguageEnum(SignInWithEN_GB),
        i18nBundles: {
            en_GB: SignInWithEN_GB,
            en_US: SignInWithEN_US
        }
    },
    SortList: {
        ...createLanguageEnum(SortListEN_GB),
        i18nBundles: {
            en_GB: SortListEN_GB,
            en_US: SortListEN_US
        }
    },
    StaticAgentControls: {
        ...createLanguageEnum(StaticAgentControlsEN_GB),
        i18nBundles: {
            en_GB: StaticAgentControlsEN_GB,
            en_US: StaticAgentControlsEN_US
        }
    },
    StatisticAlarm: {
        ...createLanguageEnum(StatisticAlarmEN_GB),
        i18nBundles: {
            en_GB: StatisticAlarmEN_GB,
            en_US: StatisticAlarmEN_US
        }
    },
    StatisticCalculations: {
        ...createLanguageEnum(StatisticCalculationsEN_GB),
        i18nBundles: {
            en_GB: StatisticCalculationsEN_GB,
            en_US: StatisticCalculationsEN_US
        }
    },
    StatusChange: {
        ...createLanguageEnum(StatusChangeEN_GB),
        i18nBundles: {
            en_GB: StatusChangeEN_GB,
            en_US: StatusChangeEN_US
        }
    },
    TalkTime: {
        ...createLanguageEnum(TalkTimeEN_GB),
        i18nBundles: {
            en_GB: TalkTimeEN_GB,
            en_US: TalkTimeEN_US
        }
    },
    TeamsAuth: {
        ...createLanguageEnum(TeamsAuthEN_GB),
        i18nBundles: {
            en_GB: TeamsAuthEN_GB,
            en_US: TeamsAuthEN_US
        }
    },
    TelModuleStatusListLanguage: {
        ...createLanguageEnum(TelModuleStatusListLanguageEN_GB),
        i18nBundles: {
            en_GB: TelModuleStatusListLanguageEN_GB,
            en_US: TelModuleStatusListLanguageEN_US
        }
    },
    TelSysConfiguration: {
        ...createLanguageEnum(TelSysConfigurationEN_GB),
        i18nBundles: {
            en_GB: TelSysConfigurationEN_GB,
            en_US: TelSysConfigurationEN_US
        }
    },
    TelsysListLanguage: {
        ...createLanguageEnum(TelsysListLanguageEN_GB),
        i18nBundles: {
            en_GB: TelsysListLanguageEN_GB,
            en_US: TelsysListLanguageEN_US
        }
    },
    TermsAndConditions: {
        ...createLanguageEnum(TermsAndConditionsEN_GB),
        i18nBundles: {
            en_GB: TermsAndConditionsEN_GB,
            en_US: TermsAndConditionsEN_US
        }
    },
    TextInputDropDown: {
        ...createLanguageEnum(TextInputDropDownEN_GB),
        i18nBundles: {
            en_GB: TextInputDropDownEN_GB,
            en_US: TextInputDropDownEN_US
        }
    },
    TimeFormats: {
        ...createLanguageEnum(TimeFormatsEN_GB),
        i18nBundles: {
            en_GB: TimeFormatsEN_GB,
            en_US: TimeFormatsEN_US
        }
    },
    TimeOptions: {
        ...createLanguageEnum(TimeOptionsEN_GB),
        i18nBundles: {
            en_GB: TimeOptionsEN_GB,
            en_US: TimeOptionsEN_US
        }
    },
    Timezone: {
        ...createLanguageEnum(TimezoneEN_GB),
        i18nBundles: {
            en_GB: TimezoneEN_GB,
            en_US: TimezoneEN_US
        }
    },
    TimezoneModal: {
        ...createLanguageEnum(TimezoneModalEN_GB),
        i18nBundles: {
            en_GB: TimezoneModalEN_GB,
            en_US: TimezoneModalEN_US
        }
    },
    UnreturnedCalls: {
        ...createLanguageEnum(UnreturnedCallsEN_GB),
        i18nBundles: {
            en_GB: UnreturnedCallsEN_GB,
            en_US: UnreturnedCallsEN_US
        }
    },
    UnreturnedCallsFilter: {
        ...createLanguageEnum(UnreturnedCallsFilterEN_GB),
        i18nBundles: {
            en_GB: UnreturnedCallsFilterEN_GB,
            en_US: UnreturnedCallsFilterEN_US
        }
    },
    UserDetailsLanguage: {
        ...createLanguageEnum(UserDetailsLanguageEN_GB),
        i18nBundles: {
            en_GB: UserDetailsLanguageEN_GB,
            en_US: UserDetailsLanguageEN_US
        }
    },
    UserInvite: {
        ...createLanguageEnum(UserInviteEN_GB),
        i18nBundles: {
            en_GB: UserInviteEN_GB,
            en_US: UserInviteEN_US
        }
    },
    UserMenu: {
        ...createLanguageEnum(UserMenuEN_GB),
        i18nBundles: {
            en_GB: UserMenuEN_GB,
            en_US: UserMenuEN_US
        }
    },
    UserNotificationTypesHelp: {
        ...createLanguageEnum(UserNotificationTypesHelpEN_GB),
        i18nBundles: {
            en_GB: UserNotificationTypesHelpEN_GB,
            en_US: UserNotificationTypesHelpEN_US
        }
    },
    UserTour: {
        ...createLanguageEnum(UserTourEN_GB),
        i18nBundles: {
            en_GB: UserTourEN_GB,
            en_US: UserTourEN_US
        }
    },
    UsersByExtension: {
        ...createLanguageEnum(UsersByExtensionEN_GB),
        i18nBundles: {
            en_GB: UsersByExtensionEN_GB,
            en_US: UsersByExtensionEN_US
        }
    },
    UsersListLanguage: {
        ...createLanguageEnum(UsersListLanguageEN_GB),
        i18nBundles: {
            en_GB: UsersListLanguageEN_GB,
            en_US: UsersListLanguageEN_US
        }
    },
    WebexAuthLanguage: {
        ...createLanguageEnum(WebexAuthLanguageEN_GB),
        i18nBundles: {
            en_GB: WebexAuthLanguageEN_GB,
            en_US: WebexAuthLanguageEN_US
        }
    }
}

export const {
    ACDCodesLanguage,
    ACDDNDActivity,
    ACDStateThresholds,
    ACDStatusHotKeys,
    AbandonedCallAlarm,
    AbandonedTimeStatisticLanguage,
    AddUserLanguage,
    AdminActionsLanguage,
    AdminOverviewLanguage,
    AdministratorLanguage,
    Advanced,
    AgentAdvanced,
    AgentDetails,
    AgentListLanguage,
    AgentOmnichannel,
    AlarmActions,
    AnswerPerformance,
    ApiKeys,
    AppMenu,
    Audit,
    Authentication,
    BrandingLanguage,
    BroadworksSSO,
    CMECapabilities,
    CMEDetails,
    CRMConfigurationLanguage,
    CRMModal,
    CSVExportFormat,
    CXRecordLanguage,
    CXScoreLanguage,
    CallControlErrors,
    CallDetails,
    CallMovementFiltering,
    CallRecIntegration,
    CallRecording,
    CallStateThresholds,
    CallTargetting,
    ChangeLangLanguage,
    ChangeLayout,
    ChangeUserAgentLanguage,
    ChartProviderOptions,
    ChartStyleOptions,
    ClientConfigurationLanguage,
    ClientConfigurationModalLanguage,
    CmeListLanguage,
    CodeAddModify,
    CodeListLanguage,
    ComboBox,
    CommonAdmin,
    ConfigChangeLogListLanguage,
    ConfigureAgents,
    ConfigureReport,
    ContentRestriction,
    CookieConsent,
    Currency,
    CurrencyDisplayFormat,
    CustomSettings,
    CustomiseRole,
    CxiLicenceTypes,
    DarkMode,
    DashboardDisplaySettings,
    DashboardList,
    DashboardOptions,
    DatabaseLanguage,
    Date,
    DateTime,
    DaysOfTheWeek,
    DeviceFiltering,
    DeviceListLanguage,
    DeviceModal,
    DeviceTypesLanguage,
    DirectoryListLanguage,
    DirectoryModal,
    DisplayOptions,
    DisplaySettings,
    DisplaySwitching,
    DisplayedAsOptions,
    DocumentViewer,
    DomainProfile,
    DurationFiltering,
    ErrorLanguage,
    Estate,
    ExtensionEndpoint,
    FieldsList,
    FieldsTab,
    FileUploadLanguage,
    ForgotPasswordLanguage,
    Format,
    GenericAdminFilterLanguage,
    GenericAdminListLanguage,
    GenericFooter,
    GenericModal,
    GenericRuleLanguage,
    GenericScopeTab,
    HeaderSidebar,
    InboundStatSettings,
    InsightsDashboardLanguage,
    InsightsHub,
    LanguageBulkInsertUsers,
    LanguageBulkUploadDirectoryEntries,
    LanguageCME,
    LanguageDataTable,
    LanguageErrorCodes,
    LanguageErrors,
    LanguageFallbackNav,
    LanguageGeneral,
    LanguageLogFileDownload,
    LanguageMainMenu,
    LanguageMainNavigation,
    LanguageMyReportList,
    LanguageNewUserTutorial,
    LanguagePrompt,
    LanguageSnackbar,
    LicenceManagementPageLanguage,
    LicenseManagement,
    LicenseManagementLanguage,
    LinkInputLanguage,
    LocationalFiltering,
    LogManagementListLanguage,
    LoggingSettingsLanguage,
    MFALanguage,
    ManageCustomRoles,
    ManageQueues,
    MediaPlayer,
    MessagesLanguage,
    MicrosoftSSO,
    MiscellaneousFiltering,
    MonetaryCallAssignments,
    NotificationsLanguage,
    NotificationsLanguageModal,
    OAuthButton,
    PaginatedList,
    PartitionListLanguage,
    PartitionModal,
    PasswordChangeLanguage,
    PasswordTextInput,
    PermissionsLanguage,
    Presence,
    Preview,
    PrintOutput,
    Provisioning,
    RangeComboLanguage,
    RecordingListLanguage,
    ReportContentRowsSettingsLanguage,
    ReportIntervalLanguage,
    ReportOptions,
    ReportPortalInfo,
    ReportScheduling,
    ReportSchedulingEmails,
    ReportTypes,
    ReportingDefaultReportSets,
    ReportingLanguage,
    ReportingMenuLanguage,
    ReportsFilterDeviceFilter,
    RichTextEditor,
    RoleLanguage,
    Router,
    RowOptions,
    RulesLanguage,
    SSOLanguage,
    ScheduleStatus,
    ScopeAssignment,
    ScopeFiltering,
    SelfProvisioning,
    ServerStatusLanguage,
    ServiceLvlSettings,
    ServiceMessagesLanguage,
    SettingsLanguage,
    SidebarMenu,
    SignInWith,
    SortList,
    StaticAgentControls,
    StatisticAlarm,
    StatisticCalculations,
    StatusChange,
    TalkTime,
    TeamsAuth,
    TelModuleStatusListLanguage,
    TelSysConfiguration,
    TelsysListLanguage,
    TermsAndConditions,
    TextInputDropDown,
    TimeFormats,
    TimeOptions,
    Timezone,
    TimezoneModal,
    UnreturnedCalls,
    UnreturnedCallsFilter,
    UserDetailsLanguage,
    UserInvite,
    UserMenu,
    UserNotificationTypesHelp,
    UserTour,
    UsersByExtension,
    UsersListLanguage,
    WebexAuthLanguage
} = languageItems
